import * as React from "react";
const SvgStop20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 2h16v16H2V2Zm2 2v12h12V4H4Z",
      clipRule: "evenodd"
    })
  );
export default SvgStop20Px;
